import { useUser } from '../contexts/UserContext';

const Header = () => {
  const { user } = useUser();

  return (
    <header className="bg-white h-16 border-b border-gray-200 flex items-center justify-end px-6 shadow-sm">
      {user && (
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-gray-700">
            {user.firstName} {user.lastName}
          </span>
          <img
            src="./defaultimages/defaultprofile.png"
            alt="Profil"
            className="h-10 w-10 rounded-full object-cover"
          />
        </div>
      )}
    </header>
  );
};

export default Header;
